
      import { main } from './src/main.tsx'
      main()
    